module.exports = __webpack_public_path__ + "img/advantage2@2x.671a3d83.png";